import {
  Box,
  ExpandableSection,
  Link,
  SpaceBetween,
} from '@amzn/awsui-components-console';

// Full step-by-step guidance lives in the Fusion User Guide so it stays in one
// maintainable place; this on-page block is a condensed orientation that links
// out for the rest.
const FLC_ENTER_BUILD_INFO_URL =
  'https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/flc-using-flc.html#flc-enter-build-info';
const FLC_PACKAGE_TYPES_URL =
  'https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/flc-using-flc.html#flc-package-types';

// Collapsed by default: the guidance is available on demand without pushing the
// package-entry fields below a large wall of intro text.
export const PackageInstructions = () => (
  <ExpandableSection headerText='How to add packages' defaultExpanded={false}>
    <SpaceBetween size={'xs'}>
      <Box variant={'p'}>
        Add the documentation package information for this launch as you would
        for normal{' '}
        <Link href={'https://fusion.docs.aws.dev/publish'}>
          Fusion Publishing
        </Link>
        , including any package dependencies (service-level checklist packages,
        service-level shared content, and ApiDoc dependencies such as Service
        Models, Doc Models, and External Models). Don&apos;t add
        &quot;global&quot; packages like AWSSharedContent.
      </Box>
      <Box variant={'p'}>
        After you choose Submit, FLC builds your docs and provides a link to the
        build status. When the build finishes, preview the output or update the
        package info to build a different commit. Choose Ready to Publish when
        your docs are ready for launch.
      </Box>
      <Box variant={'p'}>
        For full guidance, see{' '}
        <Link external href={FLC_ENTER_BUILD_INFO_URL}>
          Enter package build information
        </Link>{' '}
        in the <i>Fusion User Guide</i>. For help choosing a package type, see{' '}
        <Link external href={FLC_PACKAGE_TYPES_URL}>
          Supported package types
        </Link>
        .
      </Box>
    </SpaceBetween>
  </ExpandableSection>
);
